/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
// eslint-disable-next-line
import React from 'react'

import { COLORS } from '@btime/constants'

const Border = ({ color, noRadius, noTop, noRight, noLeft, leftColor, leftWidth, ...props }) => {
  const style = css`
    ${noRadius ? '' : 'border-radius: 5px;'}
    border: solid 1px ${color || COLORS.light3};
    ${noTop ? 'border-top: none;' : ''}
    ${noRight ? 'border-right: none;' : ''}
		${noLeft ? 'border-left: none;' : ''}
		${leftColor || leftColor ? `border-left: solid ${leftWidth || '.3rem'} ${leftColor || color || COLORS.purple};` : ''}
  `

  return <div css={style} {...props} />
}

export default Border
